import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import { Button, Col, Drawer, Popconfirm, Row } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import RichTextView from 'common/component/RichTextView';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import AddEvent from './AddEvent';
import EditEvent from './EditEvent';
import { useEvent } from '../hooks/useEvent';
import NepaliDate from 'nepali-date-converter';
import { addNumberToMonth } from 'features/result/utils/utils';
import moment from 'moment';
const { convertToBS } = require('nepali-date-converter/dist/lib/nepali-date-helper');
// import moment from 'moment';

interface Props {}

const EventView: React.FC<Props> = () => {
  const [visible, setVisible] = React.useState(false);
  const events = useSelector((state: RootState) => state.event);
  const [reloadEvent, setReloadEvent] = React.useState(true);
  const [showEditDrawer, setShowEditDrawer] = React.useState(false);
  const [selectedEvent, setSelectedEvent] = React.useState<any>(null);
  const { fetchEvent, onDeleteEvent } = useEvent();

  const handleDelete = async (id: string) => {
    await onDeleteEvent(id, setShowEditDrawer, setReloadEvent);
  };

  const TableColumn = () => [
    {
      name: 'Event',
      selector: 'title',
      sortable: true,
    },
    {
      name: 'Description',
      cell: (row: any) => (
        <div>
          <RichTextView value={row.description} />
        </div>
      ),
    },
    {
      name: 'Images',
      selector: 'images',
      sortable: true,
    },
    {
      name: 'Date',
      selector: 'date',
      sortable: true,
      cell: (row: any) => {
        const date = new Date(row.date);

        // const newDate = moment(date)
        //   .add(1, 'months')
        //   .format('YYYY-MM-DD');

        const newData = convertToBS(new Date(date));

        return (
          <div>
            {newData.BS.year}-{addNumberToMonth(newData.BS.month)}-{newData.BS.date}
          </div>
        );
      },
    },
    {
      name: 'Actions',
      selector: 'actions',
      sortable: true,
      cell: (row: any) => (
        <Row gutter={16}>
          <Col>
            <Button
              onClick={() => {
                setSelectedEvent(row);
                setShowEditDrawer(true);
              }}
            >
              <EditFilled />
            </Button>
          </Col>
          <Col>
            <Popconfirm
              // placement="topRight"
              title="Are you sure?"
              onConfirm={() => handleDelete(row.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button>
                <DeleteFilled />
              </Button>
            </Popconfirm>
          </Col>
        </Row>
      ),
    },
    // {
    //   name: 'Pass Mark',
    //   selector: 'pass_mark',
    //   sortable: true,
    // },
  ];

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const memoEventReload = useMemo(() => reloadEvent, [reloadEvent]);

  React.useEffect(() => {
    if (memoEventReload) {
      fetchEvent();
      setReloadEvent(false);
      setSelectedEvent(null);
    }
  }, [memoEventReload]);

  return (
    <EventViewWrapper>
      <KPageHeader title="Event" rightButtonTitle="Add Event" onRightButtonClick={showDrawer} />
      <Drawer
        width={780}
        title={<h2 style={{ fontWeight: 700 }}>Edit Event</h2>}
        placement="right"
        onClose={() => {
          setSelectedEvent(null);
          setShowEditDrawer(false);
        }}
        visible={showEditDrawer}
        closable={false}
      >
        {selectedEvent && (
          <EditEvent
            // eslint-disable-next-line react/jsx-props-no-spreading
            // {...selectedEvent}
            id={selectedEvent.id}
            title={selectedEvent.title}
            description={selectedEvent.description}
            images={selectedEvent.images}
            date={selectedEvent.date}
            onVisibleChange={setShowEditDrawer}
            onSetReloadEvent={setReloadEvent}
          />
        )}
      </Drawer>
      <Drawer
        width={780}
        title={<h2 style={{ fontWeight: 700 }}>Add Event</h2>}
        placement="right"
        onClose={onClose}
        visible={visible}
        closable={false}
      >
        <AddEvent onVisibleChange={setVisible} onSetReloadEvent={setReloadEvent} />
      </Drawer>
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing all the events that are currently in this system"
      />
      <section className="dataTable">
        <DataTable
          customStyles={tableCustomStyles}
          className="data-table"
          noHeader
          highlightOnHover
          pagination
          responsive={true}
          data={events.data.map((item) => ({
            id: item.id,
            title: item.title,
            description: item.description,
            images: item.images,
            date: item.date,
            created_at: item.created_at,
          }))}
          columns={TableColumn()}
        />
      </section>
    </EventViewWrapper>
  );
};

export const EventViewWrapper = styled.div`
  padding-right: 20px;
  .dataTable {
    margin-top: 20px;
  }
`;

// const EventView = () => <h1>Hellop</h1>;

export default EventView;
